/**
 * React Hook Form + shadcn Form 텍스트 입력 필드.
 * 라벨·필수 마크·Input·에러 메시지를 화면마다 동일한 패턴으로 맞춘다.
 */
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/shared/components/ui/form';
import { Input } from '@/shared/components/ui/input';
import * as React from 'react';
import type {
  Control,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

export interface FormTextFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  control: Control<TFieldValues>;
  name: TName;
  label: React.ReactNode;
  required?: boolean;
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
}

export const FormTextField = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  name,
  label,
  required,
  type = 'text',
  placeholder,
  disabled,
  className,
  inputClassName,
}: FormTextFieldProps<TFieldValues, TName>) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem className={className}>
        <FormLabel required={required}>{label}</FormLabel>
        <FormControl>
          <Input
            {...field}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            className={inputClassName}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);
